import gql from 'graphql-tag';
import {useMutation} from '@apollo/client';

const MUTATION = gql`
  mutation userVidaAccessStatusUpdate($id: String!, $status: String!) {
    userVidaAccessStatusUpdate(id: $id, status: $status) {
      id
      attributes {
        code
        value
      }
    }
  }
`;

const useUserVidaAccessStatusUpdate = (
  onCompleted = (_response: any) => {
  },
  onError = (_error: any) => {
  }
) => {
  const [action] = useMutation(MUTATION, { onCompleted, onError });

  return (id: string, status: string) => {
    return action({ variables: { id, status } });
  };
};

export default useUserVidaAccessStatusUpdate;
